// extracted by mini-css-extract-plugin
export default {"booklist-container":"BookList_booklist-container__xyu6+","book-list":"BookList_book-list__iv3gD","book-item":"BookList_book-item__BHc9c"};